import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { SelectorSimpleFactory } from "app/features/selectores/logic";

type Entity = models.FiltroStatusCamion;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    /**Errores de validacion */
    errors?: validation.Result<Entity>;
}


const LimiteGuias = SelectorSimpleFactory([25, 50, 100, 200, 300, 500, 1000, 2000], x => x, x => "" + x);


export class FiltroEditor extends React.PureComponent<Props> {
    getField = formfields(() => this.props, () => this.props.errors || {});

    render() {
        const { getField, props } = this;
        const Camion = getField(selectores.Camion);
        const DateTime = getField(kea.DateTime);
        const Limite = getField(LimiteGuias);
        return (
            <div>
                {kea.autogrid(3, [
                    <Camion field="IdCamion" label="Camión" />,
                    <DateTime field="FechaInicio" label="Fecha de inicio" />,
                    <DateTime field="FechaFinal" label="Fecha final" />,
                    <Limite field="Limite" label="Limite" />,
                ])}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscamion/list/filtro.tsx